// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '@/App'
import axios from '@/http'
import store from '@/store/store'
import router from '@/router'
import lodash from 'lodash'
import $ from 'jquery'
import VueLodash from 'vue-lodash'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import BigDecimal from 'js-big-decimal'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/icon/iconfont.css'
import '@/assets/css/base.css'
import common from '@/commom/common.js'
import * as filter from '@/utils/filter.js'
import moment from 'moment'
import vueMoment from 'vue-moment'
import VueI18n from 'vue-i18n'
import SWSBreadcrumb from '@/components/common/SWSBreadcrumb'
import Func from '@/constant/Func.Constants'
import Pagging from '@/constant/Pagging.Constants'
import ElementLocale from 'element-ui/lib/locale'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import eltTransfer from 'bpo-elt-transfer'
import * as echarts from 'echarts'

promise.polyfill()
Vue.config.productionTip = false
Vue.component('SWSBreadcrumb', SWSBreadcrumb)
Vue.use(Func)
Vue.use(Pagging)
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(VueLodash, {
  name: 'Vue-lodash-plugin',
  lodash: lodash
})
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: elementZhLocale
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
export default i18n
// 使用插件将Axios挂载到Vue上，使用this访问
Vue.use(VueAxios, axios)
Vue.prototype.common = common
Vue.prototype.filter = filter
Vue.prototype.BigDecimal = BigDecimal
Vue.prototype.$echarts = echarts
// vue-moment 附带了全局挂载，使用this.$moment访问
moment.locale('zh')
Vue.use(vueMoment, {moment})
Vue.use(eltTransfer)
// Vue.prototype.moment = moment
/* eslint-disable no-new */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  render: h => h(App),
  i18n,
  store
}).$mount('#app')

Vue.directive('dateFormat', {
  inserted: function (el, binding, vnode) {
    const { value: _obj } = binding
    const { context: that, data, componentInstance } = vnode
    const { expression: key } = data.model

    if(that && that._isVue) {
      const $this = $($(el).children('input')[0])

      $this.on('change', function() {
        let value = $this.val()
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3') // 格式化输入格式

        let keys = key.split('.')

        // 自定义赋值
        if (_obj) {
          const { keys: keyList } = _obj
          keys = keyList
        }

        if (keys && keys.length >= 2) {
          const [key1, key2, key3, key4] = keys

          if (key4) {
            that[key1][key2][key3][key4] = value
          } else if (key3) {
            that[key1][key2][key3] = value
          } else {
            that[key1][key2] = value
          }
        } else {
          that[key] = value
        }
      })
    }
  }
})
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
	let ariaEls = el.querySelectorAll('.el-radio__original');
	ariaEls.forEach((item) => {
	  item.removeAttribute('aria-hidden');
	})
  }
});
Vue.directive('stickyScrollBar', {
  componentUpdated(el) {
    if (el.className.indexOf('el-table') === -1 && el.className.indexOf('bpo-main-table') === -1) {
      console.warn('This directive should only be used in a element table. And may be only in this particular BPO system too.')
      return
    }

    //This guy provide the original scrollbar.
    let origin = el.querySelector('.el-table__body-wrapper')

    //Hide the original scroll bar.
    origin.style.overflowX = 'hidden'

    //Create a fake element, simply copy the above el or use the exist one.
    let copy = el.querySelector('.bpo__sticky-scrollbar')
    if (!copy) {
      copy = origin.cloneNode(true)
      el.appendChild(copy)
    }

    copy.innerHTML = ''
    copy.appendChild(document.createElement('div'))
    copy.firstChild.className = '.bpo__sticky-scrollbar__inner'

    copy.className = 'bpo__sticky-scrollbar'

    //Scrollbar won't be rendered if it is empty, so give it some.
    copy.firstChild.style.height = '0.5px'

    //Make it sticky and keep it to the top
    copy.style.overflowX = 'auto'
    copy.style.zIndex = '11'
    copy.style.position = 'sticky'

    //Yeah, me confuse too... kek
    copy.style.bottom = '-35px'

    const callback = () => {
      origin.scrollTo(copy.scrollLeft, copy.scrollTop)
    }
    copy.removeEventListener('scroll', callback)
    copy.addEventListener('scroll', callback)

    //Wait the table render finish, and resize the copy.
    setImmediate(() => copy.firstChild.style.width = origin.firstChild.style.width)
  }
})
